module.exports = __webpack_public_path__ + "img/Toyota-2019-Corolla-2.5a9610b8.png";